import {Action, getModule, Module, Mutation, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {ICurrency} from "@/entity/currency/currency.types";
import {IStoreReady} from "@/store/lib/storeSupport";

@Module({
    namespaced: true,
    name: 'currency',
    store,
    dynamic: true,
})
class CurrencyModule extends VuexModule implements IStoreReady {
    currency: ICurrency[] = [];
    ready = false

    @MutationAction
    async fetchAll(): Promise<{ currency: ICurrency[]; }> {
        const currency = await store.$repository.currency.fetchAll();
        return {currency};
    }

    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.currency.delete({id: id});
    }

    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }
}

export const CurrencyStore = getModule(CurrencyModule);
